// AutoLanding.jsx
import { Navigate } from "react-router-dom";
import { getIdentifier } from "./auth";

export default function AutoLanding() {
  const id = getIdentifier();
  return id ? <Navigate to="/home-page" replace /> : <Navigate to="/welcome" replace />;
}
